import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedMoney = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 72 72" width={width} height={height}>
            <path
                className={styles.cls1}
                d="M36.21,71.21c-19.49,0-35.34-15.85-35.34-35.34S16.73,0.53,36.21,0.53s35.34,15.85,35.34,35.34
	S55.7,71.21,36.21,71.21z M36.21,4.13c-17.5,0-31.74,14.24-31.74,31.74s14.24,31.74,31.74,31.74s31.74-14.24,31.74-31.74
	S53.72,4.13,36.21,4.13z"
            />
            <g>
                <g>
                    <path
                        className={styles.cls1}
                        d="M35.77,43.93c-2.86,0-5.19-1.94-5.19-4.32c0-0.36,0.29-0.64,0.64-0.64c0.36,0,0.64,0.29,0.64,0.64
			c0,1.67,1.75,3.03,3.9,3.03c2.15,0,3.9-1.36,3.9-3.03c0-1.67-1.75-3.03-3.9-3.03c-2.86,0-5.19-1.94-5.19-4.32
			c0-2.38,2.33-4.32,5.19-4.32c2.86,0,5.19,1.94,5.19,4.32c0,0.36-0.29,0.64-0.64,0.64c-0.36,0-0.64-0.29-0.64-0.64
			c0-1.67-1.75-3.03-3.9-3.03c-2.15,0-3.9,1.36-3.9,3.03c0,1.67,1.75,3.03,3.9,3.03c2.86,0,5.19,1.94,5.19,4.32
			C40.95,41.99,38.63,43.93,35.77,43.93z"
                    />
                    <path
                        className={styles.cls1}
                        d="M35.77,44.53c-3.19,0-5.79-2.21-5.79-4.92c0-0.69,0.56-1.24,1.24-1.24c0.69,0,1.24,0.56,1.24,1.24
			c0,1.34,1.48,2.43,3.3,2.43c1.82,0,3.3-1.09,3.3-2.43c0-1.34-1.48-2.43-3.3-2.43c-3.19,0-5.79-2.21-5.79-4.92
			c0-2.71,2.6-4.92,5.79-4.92c3.19,0,5.79,2.21,5.79,4.92c0,0.69-0.56,1.24-1.24,1.24s-1.24-0.56-1.24-1.24
			c0-1.34-1.48-2.43-3.3-2.43c-1.82,0-3.3,1.09-3.3,2.43c0,1.34,1.48,2.43,3.3,2.43c3.19,0,5.79,2.21,5.79,4.92
			C41.55,42.32,38.96,44.53,35.77,44.53z M31.27,39.61c-0.09,2.05,1.97,3.72,4.5,3.72c2.53,0,4.59-1.67,4.59-3.72
			c0-2.05-2.06-3.72-4.59-3.72c-2.48,0-4.5-1.63-4.5-3.63s2.02-3.63,4.5-3.63c2.48,0,4.5,1.63,4.5,3.63
			c0.09-2.05-1.97-3.72-4.5-3.72c-2.53,0-4.59,1.67-4.59,3.72c0,2.05,2.06,3.72,4.59,3.72c2.48,0,4.5,1.63,4.5,3.63
			s-2.02,3.63-4.5,3.63C33.29,43.24,31.27,41.61,31.27,39.61z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={styles.cls1}
                        d="M35.77,29.24c-0.36,0-0.64-0.29-0.64-0.64v-2.35c0-0.36,0.29-0.64,0.64-0.64c0.36,0,0.64,0.29,0.64,0.64v2.35
			C36.41,28.95,36.12,29.24,35.77,29.24z"
                    />
                    <path
                        className={styles.cls1}
                        d="M35.77,29.84c-0.69,0-1.24-0.56-1.24-1.24v-2.35c0-0.69,0.56-1.24,1.24-1.24c0.69,0,1.24,0.56,1.24,1.24v2.35
			C37.01,29.28,36.45,29.84,35.77,29.84z M35.81,26.24l-0.09,2.35l0.04,0.04c0.02,0,0.04-0.02,0.04-0.04V26.24z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={styles.cls1}
                        d="M35.77,46.29c-0.36,0-0.64-0.29-0.64-0.64v-2.35c0-0.36,0.29-0.64,0.64-0.64c0.36,0,0.64,0.29,0.64,0.64v2.35
			C36.41,46,36.12,46.29,35.77,46.29z"
                    />
                    <path
                        className={styles.cls1}
                        d="M35.77,46.88c-0.69,0-1.24-0.56-1.24-1.24v-2.35c0-0.69,0.56-1.24,1.24-1.24c0.69,0,1.24,0.56,1.24,1.24v2.35
			C37.01,46.33,36.45,46.88,35.77,46.88z M35.81,43.29l-0.09,2.35l0.04,0.04c0.02,0,0.04-0.02,0.04-0.04V43.29z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={styles.cls1}
                        d="M36.21,52.92c-9.4,0-17.04-7.65-17.04-17.04s7.65-17.04,17.04-17.04c9.4,0,17.04,7.65,17.04,17.04
			S45.61,52.92,36.21,52.92z M36.21,20.12c-8.69,0-15.76,7.07-15.76,15.76c0,8.69,7.07,15.76,15.76,15.76
			c8.69,0,15.76-7.07,15.76-15.76C51.97,27.19,44.9,20.12,36.21,20.12z"
                    />
                    <path
                        className={styles.cls1}
                        d="M36.21,53.52c-9.73,0-17.64-7.92-17.64-17.64c0-9.73,7.92-17.64,17.64-17.64c9.73,0,17.64,7.92,17.64,17.64
			C53.86,45.6,45.94,53.52,36.21,53.52z M36.21,19.43c-9.07,0-16.44,7.38-16.44,16.44s7.38,16.44,16.44,16.44
			s16.44-7.38,16.44-16.44S45.28,19.43,36.21,19.43z M36.21,52.23c-9.02,0-16.36-7.34-16.36-16.36c0-9.02,7.34-16.36,16.36-16.36
			c9.02,0,16.36,7.34,16.36,16.36C52.57,44.89,45.23,52.23,36.21,52.23z M36.21,20.72c-8.36,0-15.16,6.8-15.16,15.16
			s6.8,15.16,15.16,15.16s15.16-6.8,15.16-15.16S44.57,20.72,36.21,20.72z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={styles.cls1}
                        d="M36.21,58.14c-12.28,0-22.26-9.99-22.26-22.26s9.99-22.26,22.26-22.26c12.27,0,22.26,9.99,22.26,22.26
			S48.49,58.14,36.21,58.14z M36.21,15.04c-11.49,0-20.84,9.35-20.84,20.84s9.35,20.84,20.84,20.84c11.49,0,20.84-9.35,20.84-20.84
			S47.7,15.04,36.21,15.04z"
                    />
                    <path
                        className={styles.cls1}
                        d="M36.21,58.8c-12.64,0-22.93-10.28-22.93-22.92c0-12.64,10.28-22.93,22.93-22.93
			c12.64,0,22.92,10.28,22.92,22.93C59.14,48.51,48.85,58.8,36.21,58.8z M36.21,14.28c-11.91,0-21.6,9.69-21.6,21.6
			s9.69,21.6,21.6,21.6s21.6-9.69,21.6-21.6S48.12,14.28,36.21,14.28z M36.21,57.37c-11.86,0-21.5-9.64-21.5-21.5
			c0-11.86,9.64-21.5,21.5-21.5c11.85,0,21.5,9.64,21.5,21.5C57.71,47.73,48.07,57.37,36.21,57.37z M36.21,15.7
			c-11.12,0-20.17,9.05-20.17,20.17s9.05,20.17,20.17,20.17S56.39,47,56.39,35.87S47.34,15.7,36.21,15.7z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default GetStartedMoney;
